import { Row, Col } from 'antd';
import styled from 'styled-components';

const StyledRow = styled(Row)`
  > .row-title {
    font-size: 16px;
    font-weight: 600;
  }
`;
//  display: flex;
const StyledCol = styled(Col)`
  align-items: start;
  gap: 6px;

  > label {
    color: rgba(0, 0, 0, 0.5);
  }
`;

export const ProfileRow = ({ title, children, ...props }) => {
  return (
    <StyledRow gutter={[24, 16]} {...props}>
      {title && (
        <Col span={24} className="row-title">
          {title}
        </Col>
      )}
      {children}
    </StyledRow>
  );
};

export const ProfileCol = ({ label, value, children, ...props }) => {
  return (
    <StyledCol xs={24} {...props}>
      {label && <label>{label}:</label>}
      <div style={{ flex: 1, whiteSpace: 'pre-wrap' }}>{value === undefined ? children : value}</div>
    </StyledCol>
  );
};
